export default __webpack_public_path__ + "static/media/GothamMediumItalic.b35ab0df.ttf";